export default "__VITE_ASSET__DxagrFgd__"